import { TableCellInputType } from "@components/data-table/types";
import { AssetTableColumnFromApi } from "@hooks/use-config-context/asset/types";
import { FieldsConfigResponse } from "@hooks/use-config-context/types";
import {
  getFieldInputType,
  getValueFromMetaBox,
} from "@hooks/use-config/utils";

// Google Sync (Chrome/Google device management) fields — default-hidden in
// the Assets table (still toggleable via column settings) and excluded from
// the dashboard Asset chart's column picker entirely.
// NOTE: field ids guessed from naming convention — confirm/correct against
// the actual backend field config if any of these don't match.
export const ASSET_GOOGLE_SYNC_COLUMN_IDS = [
  "google_device_id",
  "google_device_type",
  "google_last_sync",
  "google_device_status",
  "os_version",
] as const;

export const getTableColumnsFromFields = (
  fields: FieldsConfigResponse,
): AssetTableColumnFromApi[] => {
  const labels = Object.values(fields).reduce((acc, field) => {
    if (field.name && field.display !== false) {
      acc.push({
        id: field.id,
        label: field.name,
        getValue: (asset) => getValueFromMetaBox(asset, field.id),
        inputType: getFieldInputType(field),
        clone: field.clone || false,
      });
    }
    return acc;
  }, [] as AssetTableColumnFromApi[]);
  labels.unshift({
    id: "title",
    label: "Asset Tag",
    getValue: (asset) => asset.title.rendered,
    inputType: TableCellInputType.Text,
    clone: false,
  });
  labels.unshift({
    id: "id",
    label: "ID",
    getValue: (asset) => asset.id,
    inputType: TableCellInputType.SystemProvided,
    clone: false,
  });

  return labels;
};
